<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box d-none d-lg-inline-block">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/img/logo.png" width="20px" alt="" class="img-fluid">
          </span>
          <span class="logo-lg">
            <img src="assets/img/logo.png" width="20px" alt="" class="img-fluid">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/img/logo-min-dark.png" width="40px">
          </span>
          <span class="logo-lg">
            <img src="assets/img/logo-dark.png" width="130px" class="img-fluid">
          </span>
        </a>
      </div>
    </div>

    <button type="button" class="btn btn-sm px-3 font-size-16" id="vertical-menu-btn"
      (click)="toggleMobileMenu($event)">
      <i class="fa fa-fw fa-bars"></i>
    </button>
    <div style="margin-right: auto;" class="d-flex align-items-center gap-1 gap-md-2 overflow-hidden flex-nowrap">
      <div class="my-auto me-1 me-md-2 flex-shrink-0" [formGroup]="form">
        @if (this.sucursales() && this.sucursales().length > 0) {
        <p-select [options]="sucursales()" [style]="this.styleSucursales()" optionLabel="name" optionValue="id"
          appendTo="body" formControlName="id_sucursal" (onChange)="setStoragesBySucursal()">
        </p-select>
        }
      </div>

    </div>

    <div class="d-flex">

      <!-- <div class="dropdown d-inline-block" dropdown>
      <button type="button" class="btn header-item" id="page-header-user-dropdown" dropdownToggle>
        <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="16">
        <img *ngIf="flagvalue === undefined" src="{{valueset}}" alt="Header Language" height="16">
      </button>
      <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
        <a href="javascript:void(0);" class="dropdown-item notify-item" *ngFor="let item of listLang"
          (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
          <img src="{{item.flag}}" alt="user-image" class="me-1" height="12"> <span
        class="align-middle">{{item.text}}</span>
      </a>
    </div>
  </div> -->

      <!-- Dark / Light Mode Direct Toggle -->
      <div class="dropdown d-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon theme-toggle-btn"
          [title]="currentTheme() === 'dark' ? 'Cambiar a Modo Claro' : 'Cambiar a Modo Oscuro'"
          (click)="toggleThemeMode($event)">
          @if (currentTheme() === 'dark') {
          <i class="bx bx-sun text-warning"></i>
          } @else {
          <i class="bx bx-moon"></i>
          }
        </button>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" title="Pantalla Completa" data-toggle="fullscreen"
          (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1" dropdown>
        <button type="button" class="btn header-item noti-icon" title="Datos CUFD" dropdownToggle>
          <i class="bx bx-customize"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" *dropdownMenu>
          <div class="px-lg-3">
            @if (dataCufd) {
            <div>
              <p style="word-wrap: break-word; white-space: normal;">
                <i class="fas fa-barcode me-2"></i><b>CUFD:</b> {{ dataCufd.cufd }}
              </p>
              <p><i class="fas fa-shield-alt me-2"></i><b>Código de Control:</b> {{ dataCufd.controlCode }}</p>
              <p><i class="fas fa-calendar-plus me-2"></i><b>Creado:</b> {{
                dataCufd.createdCufd | date:'dd-MM-yyyy HH:mm:ss'
                }}</p>
              <p [ngClass]="{
                    'text-danger': isExpired(dataCufd.expireCufd),
                    'text-success': !isExpired(dataCufd.expireCufd)
                  }">
                <i class="fas fa-calendar-times me-2"></i><b>Expira:</b> {{
                dataCufd.expireCufd | date:'dd-MM-yyyy HH:mm:ss'
                }}
              </p>
              <button class="btn btn-sm btn-primary mt-2" (click)="generateNewCufd()">
                <i class="fas fa-sync-alt me-1"></i> Generar nuevo CUFD
              </button>
            </div>
            } @else {
            <p class="text-danger">CUFD no encontrado.</p>
            <button class="btn btn-sm btn-primary mt-2" (click)="generateNewCufd()">
              <i class="fas fa-sync-alt me-1"></i> Generar CUFD
            </button>
            }

          </div>
        </div>
      </div>

      <!-- NOTIFICACIONES -->
      <!-- <div class="dropdown d-inline-block" dropdown>
<button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
  dropdownToggle>
  <i class="bx bx-bell bx-tada"></i>
  <span class="badge bg-danger rounded-pill">3</span>
</button>
<div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
  aria-labelledby="page-header-notifications-dropdown" *dropdownMenu>
  <div class="p-3">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="m-0">{{ 'HEADER.NOTIFICATIONS.TITLE' | translate}} </h6>
      </div>
      <div class="col-auto">
        <a href="javascript: void(0);" class="small">{{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate}}</a>
      </div>
    </div>
  </div>
  <ngx-simplebar style="position: relative; height: 230px;">
    <a href="javascript: void(0);" class="text-reset notification-item">
      <div class="d-flex">
        <div class="avatar-xs me-3">
          <span class="avatar-title bg-primary rounded-circle font-size-16">
            <i class="bx bx-cart"></i>
          </span>
        </div>
        <div class="flex-grow-1">
          <h6 class="mb-1">{{ 'HEADER.NOTIFICATIONS.FIRST.TITLE' | translate}}</h6>
          <div class="font-size-12 text-muted">
            <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.FIRST.TEXT' | translate}}</p>
            <p class="mb-0"><i class="mdi mdi-clock-outline"></i>
          {{ 'HEADER.NOTIFICATIONS.FIRST.TIME' | translate}}</p>
        </div>
      </div>
    </div>
  </a>
  <a href="javascript: void(0);" class="text-reset notification-item">
    <div class="d-flex">
      <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
      <div class="flex-grow-1">
        <h6 class="mb-1">{{ 'HEADER.NOTIFICATIONS.SECOND.TITLE' | translate}}</h6>
        <div class="font-size-12 text-muted">
          <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.SECOND.TEXT' | translate}}</p>
          <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.SECOND.TIME' |
        translate}}</p>
      </div>
    </div>
  </div>
</a>
</ngx-simplebar>
<div class="p-2 border-top d-grid">
  <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
    <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{{
  'HEADER.NOTIFICATIONS.LOAD_MORE' | translate}}</span>
</a>
</div>
</div>
</div> -->

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item d-flex align-items-center" dropdownToggle
          id="page-header-user-dropdown">
          <ng-container *ngIf="showLogoImage; else initialsBadge">
            <img class="rounded-circle header-profile-user" [src]="logoUrl" (error)="onLogoError()" alt="Logo">
          </ng-container>
          <ng-template #initialsBadge>
            <div class="rounded-circle header-avatar-initials">
              {{ userInitials }}
            </div>
          </ng-template>
          <span class="d-none d-xl-inline-block ms-2 font-size-13 fw-semibold text-truncate"
            style="max-width: 170px;">{{ getUserName }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block ms-1"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/management/profile"><i
              class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate }}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger cursor-pointer" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate }}</a>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleRightSidebar()">
          <i class="bx bx-cog"></i>
        </button>
      </div>

    </div>
  </div>

  <!-- ALERTAS EMERGENTES FLOTANTES (Stack de Toasts con Glassmorphism) -->
  @if (activeAlerts().length > 0) {
  <div class="floating-alerts-container" [class.position-bottom-right]="hasNonDismissibleAlert()">
    @for (alert of activeAlerts(); track alert.type) {
    <aside class="floating-alert-toast toast-level-{{ alert.level.toLowerCase() }} shadow-lg animate__animated"
      [class.animate__fadeInUp]="hasNonDismissibleAlert()"
      [class.animate__fadeInDown]="!hasNonDismissibleAlert()"
      role="alert" aria-live="polite">
      <div class="d-flex align-items-start gap-3">
        
        <!-- Icono contextual con pulso -->
        <div class="floating-toast-icon-box flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle">
          @if (alert.type === 'DIGITAL_SIGNATURE') {
            <i class="fas fa-shield-alt font-size-18"></i>
          } @else if (alert.type === 'SIAT_TOKEN') {
            <i class="fas fa-key font-size-18"></i>
          } @else {
            <i class="fas fa-exclamation-circle font-size-18"></i>
          }
        </div>

        <!-- Contenido y mensaje -->
        <div class="flex-grow-1 min-w-0">
          <div class="d-flex align-items-center gap-2 mb-1.5 flex-wrap">
            <span class="floating-toast-title fw-bold font-size-13">
              @if (alert.type === 'DIGITAL_SIGNATURE') {
                Firma Digital SIAT
              } @else if (alert.type === 'SIAT_TOKEN') {
                Token Delegado SIAT
              } @else {
                Suscripción Clickbo
              }
            </span>
            <span class="badge rounded-pill font-size-10 fw-semibold floating-toast-badge">
              @if (alert.level === 'CRITICAL') {
                VENCIDO
              } @else if (alert.level === 'URGENT') {
                ¡VENCE EN {{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'DÍA' : 'DÍAS' }}!
              } @else {
                Vence en {{ alert.daysRemaining }} días
              }
            </span>
          </div>

          <p class="floating-toast-message mb-2.5 font-size-12">
            @if (alert.type === 'DIGITAL_SIGNATURE') {
              @if (alert.level === 'CRITICAL') {
                Tu Certificado Digital ha expirado. No es posible firmar ni emitir facturas electrónicas.
              } @else {
                Tu Firma Digital vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong>). Tramita tu renovación ante ADSIB.
              }
            } @else if (alert.type === 'SIAT_TOKEN') {
              @if (alert.level === 'CRITICAL') {
                Tu Token Delegado SIAT ha expirado. La emisión de facturas electrónicas ante el SIN está pausada.
              } @else {
                Tu Token delegado vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan <strong>{{ alert.daysRemaining }} {{ alert.daysRemaining === 1 ? 'día' : 'días' }}</strong>). Actualízalo ante el SIN para evitar cortes.
              }
            } @else {
              @if (alert.level === 'CRITICAL') {
                Tu suscripción está vencida. Regularízala para continuar emitiendo facturas.
              } @else {
                Tu plan vence el <strong>{{ alert.expirationDate | date:'dd/MM/yyyy' }}</strong> (restan <strong>{{ alert.daysRemaining }} días</strong>). Recuerda renovar a tiempo.
              }
            }
          </p>

          <!-- Botones de Acción -->
          <div class="d-flex align-items-center gap-2 flex-wrap">
            @if (alert.type === 'DIGITAL_SIGNATURE') {
              <a [href]="alert.whatsappUrl" target="_blank"
                class="btn btn-sm btn-success rounded-pill px-3 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                title="Asistencia por WhatsApp">
                <i class="bx bxl-whatsapp font-size-14"></i>
                <span>Renovar por WhatsApp</span>
              </a>
              <a routerLink="/profile/user"
                class="btn btn-sm btn-outline-secondary rounded-pill px-2.5 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm"
                title="Ver Firma en Perfil">
                <i class="fas fa-user-cog font-size-11"></i>
                <span>Perfil</span>
              </a>
            } @else if (alert.type === 'SIAT_TOKEN') {
              <button type="button"
                class="btn btn-sm btn-primary rounded-pill px-3 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                (click)="openRefreshTokenModal()" title="Actualizar Token Delegado SIAT">
                <i class="fas fa-sync-alt font-size-11"></i>
                <span>Actualizar Token</span>
              </button>
              <a [href]="alert.whatsappUrl" target="_blank"
                class="btn btn-sm btn-success rounded-pill px-2.5 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                title="Asistencia por WhatsApp">
                <i class="bx bxl-whatsapp font-size-14"></i>
                <span>Ayuda</span>
              </a>
            } @else {
              <a [href]="alert.whatsappUrl" target="_blank"
                class="btn btn-sm btn-success rounded-pill px-3 py-1 font-size-11 fw-semibold d-inline-flex align-items-center gap-1.5 shadow-sm"
                [title]="alert.level === 'CRITICAL' ? 'Contactar a Ventas' : 'Renovar por WhatsApp'">
                <i class="bx bxl-whatsapp font-size-14"></i>
                <span>{{ alert.level === 'CRITICAL' ? 'Contactar a Ventas' : 'Renovar por WhatsApp' }}</span>
              </a>
            }
          </div>
        </div>

        <!-- Botón de Cierre Notorio y Táctil -->
        @if (alert.isDismissible) {
        <button type="button"
          class="btn floating-toast-close flex-shrink-0 d-flex align-items-center justify-content-center"
          (click)="closeAlert(alert.type)"
          aria-label="Cerrar aviso"
          title="Cerrar aviso">
          <i class="bx bx-x"></i>
        </button>
        }

      </div>
    </aside>
    }
  </div>
  }
</header>